export default __webpack_public_path__ + "static/media/popup_pergaminhos_02.3c72d2bf.mp3";